import Smartphones from 'Projects/views/ProjectView/Create/containers/Smartphones'
import Tablets from 'Projects/views/ProjectView/Create/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const ProjectCreateView = getCurrentDeviceView(Smartphones, Tablets)

export default ProjectCreateView
